// extracted by mini-css-extract-plugin
export default {"label_spec":"CustomerDetails_label_spec__D25Mz","customer_details":"CustomerDetails_customer_details__Y7JWT"};